import { TitleContainer } from "@/components/HeaderContainer";
import { LightThemedButton, ThemedButton } from "@/components/ThemedButton";
import useLoginSession from "@/hooks/useLoginSession";
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";

function ModalRescheduleDesc() {
	const { isLoginBySession } = useLoginSession();

	let navigate = useNavigate();
	const location = useLocation();
	const learner_id = location.state?.data?.learner_id || location.state?.learner_id;

	if (!learner_id) {
		navigate("/course");
	}

	const handleBack = () => {
		if (isLoginBySession && window.ReactNativeWebView) {
			window.ReactNativeWebView.postMessage(
				JSON.stringify({
					status: "error",
				}),
			);
		} else {
			navigate(-1);
		}
	};

	return (
		<div className='reschedule_main_container'>
			{/* <div className='title-container'>
						<span className='fs40 text-fca-dark font_2'>Reschedule</span>
					</div> */}
			<TitleContainer>Reschedule</TitleContainer>
			<div>
				<Card className='mt-2'>
					<CardBody>
						<p className='fs18 text-fca-dark'>
							According to our Terms & Conditions during your enrolment, kindly note that the
							administrative fee will be waived for the first reschedule request. Subsequent
							reschedule requests are chargeable at 10% of full course fees. To appeal for a waiver
							on administrative fees, please attach supporting documents for our review.
						</p>
						<p className='fs18 mt-2 mb-2 font-weight-bold text-fca-dark'>
							{"Reschedule Request & Fees"}
						</p>
						<div className='p-4 mb-4' style={{ backgroundColor: "#DEECF3" }}>
							<p className='fs18 font-weight-bold text-fca-dark'>
								{"• 1st Reschedule"}
								<span className='fs18 font-weight-300 text-fca-dark'>{" - No charge"}</span>
							</p>
							<p className='fs18 font-weight-bold text-fca-dark'>
								{"• 2nd and Subsequent Reschedules"}
								<span className='fs18 font-weight-300 text-fca-dark'>
									{" - 10% of full course fees (Waivable with valid reasons)"}
								</span>
							</p>
						</div>
						<p className='fs18 text-fca-dark'>
							A maximum of three (3) reschedule requests is allowed. There will be no rescheduling
							allowed after the 3rd reschedule and the enrolment will be considered as a no-show.
						</p>
						<Col md='12' xl='12'>
							<div className='flex justify-content-end gap-1 mb-4 mt-6'>
								<LightThemedButton onClick={handleBack}>Back</LightThemedButton>
								<ThemedButton
									component={Link}
									to='/course/reschedule'
									state={{
										learner_id: learner_id,
									}}>
									Proceed to Reschedule
								</ThemedButton>
							</div>
						</Col>
					</CardBody>
				</Card>
			</div>
		</div>
	);
}

export default ModalRescheduleDesc;
